import React from 'react'
import { InputNumber } from 'primereact/inputnumber'
import './inputComp.scss'

const InputNumberComp = ({
  name,
  value,
  onChange,
  useGrouping = false,
  ...propsInput
}) => {
  return (
    <InputNumber
      name={name}
      value={value}
      onChange={(e) => {
        onChange({
          target: { name: e.originalEvent.target.name, value: e.value },
        })
      }}
      useGrouping={useGrouping}
      {...propsInput}
    />
  )
}

export default InputNumberComp
